import React, { useEffect, useState } from "react"
import { Col, Form, Row, ButtonGroup, Button } from "react-bootstrap"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import toast from "react-hot-toast"
import {
  isAdmin,
  toastStyle,
  numberFormat,
  selectDropdownStyle,
  antdesignSelectStyle,
} from "../../../Helpers/Utils/Common"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import * as XLSX from "xlsx"

//components
import TableTemplate from "../../../Components/TableTemplate/DataTable"
import Navbar from "../../../Components/Navbar/Navbar"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import AddModal from "../../../Components/Modals/AddModal"
import EditModal from "../../../Components/Modals/EditModal"
import ViewModal from "../../../Components/Modals/ViewModal"

//css
import "./../Manage.css"
import "../../../Components/Navbar/Navbar.css"

//api
import {
  getItemPrices,
  createItemPrice,
  searchItemPrice,
  deleteItemPrices,
  updateItemPrice,
} from "../../../Helpers/apiCalls/Manage/ItemPrice"
import { refreshPage } from "../../../Helpers/Utils/Common"
import { searchItem } from "../../../Helpers/apiCalls/itemsApi"
import {
  getAllPriceLevelsBasedOnItem,
  searchPriceLevel,
} from "../../../Helpers/apiCalls/Manage/PriceLevels"
import { useLocation } from "react-router-dom"
import { getCategory } from "../../../Helpers/apiCalls/categoryApi"
import moment from "moment"
import Footer from "../../../Components/Footer/Footer"

export default function ItemPricesV2() {
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const { state } = useLocation()
  const [searchValue, setSearchValue] = useState(state ? state.name : "")
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const [excelData, setExcelData] = useState([])
  const [filterConfig, setFilterConfig] = useState({
    anything: state ? state.name : "",
    type: "",
  })
  const xlsxBarcodeHeaders = [
    "QTY",
    "BARCODE",
    "ITEM CODE",
    "DESCRIPTION",
    "PRICE",
    "AMOUNT",
  ]

  const xlsxHeaders = [
    "ITEM NAME",
    "UNIT",
    "PRICE LEVEL",
    "SELLING PRICE",
    "WHOLESALE PRICE",
    "RETAIL PRICE",
  ]

  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  // VIEW
  const [showViewItemModal, setShowViewItemModal] = useState(false)
  const handleShowViewItemModal = () => setShowViewItemModal(true)
  const handleCloseViewItemModal = () => {
    setShowViewItemModal(false)
  }

  // EDIT
  const [showEditItemModal, setShowEditItemModal] = useState(false)
  const handleShowEditItemModal = () => setShowEditItemModal(true)
  const handleCloseEditItemModal = () => {
    refreshPage()
    setShowEditItemModal(false)
  }

  // select item modal handler
  const [showSelectItemModal, setShowSelectItemModal] = useState(false)
  const handleShowSelectItemModal = () => {
    setItemDetails({})
    setShowSelectItemModal(true)
  }
  const handleCloseSelectItemModal = () => {
    setShowSelectItemModal(false)
  }

  // ADD
  const [showAddItemModal, setShowAddItemModal] = useState(false)
  const handleShowAddItemModal = () => {
    handleCloseSelectItemModal()
    setShowAddItemModal(true)
  }
  const handleCloseAddItemModal = () => {
    refreshPage()
    setShowAddItemModal(false)
  }

  //API
  const [itemsDataBraddex, setItemsDataBraddex] = useState([])
  const [selectedRow, setSelectedRow] = useState({})
  const [selectedID, setSelectedID] = useState("")
  const [itemDetails, setItemDetails] = useState({})
  const [priceLevel, setPriceLevels] = useState([])
  const [filteredPriceLevel, setFilteredPriceLevels] = useState([])
  const [allPriceLevel, setAllPriceLevels] = useState([])
  const [priceLevelDetails, setPriceLevelDetails] = useState([[]]) //array of array of objects

  const [saleItems, setSaleItems] = useState([])
  const [saleItemsValue, setSaleItemsValue] = useState({
    name: "item_id",
    label: "",
    value: "",
  })
  const [itemsUnitsMap, setItemsUnitsMap] = useState([
    {
      unit_from: "",
      value_from: "",
      unit_to: "",
      value_to: "",
      minimum: "",
      maximum: "",
      acceptable_variance: "",
    },
  ])

  const handleAddChange = (e, type) => {
    if (type === "item_id") {
      var item_name = saleItems.filter((data) => {
        return data.value === e
      })
      setItemDetails((prevState) => ({
        ...prevState,
        item_id: item_name[0].value,
        item_unit_id: item_name[0].value,
        unit: item_name[0].unit_from_name,
        type: item_name[0].type,
        name: item_name[0].name,
        item_units: item_name[0].item_units,
        item_id_value: {
          label: item_name[0].label,
          value: item_name[0].value,
        },
      }))
      fetchPriceLevelPerItem(e, item_name[0])
    } else if (type === "dropdown") {
      if (e.var_name === "item_id") {
        setItemDetails((prevState) => ({
          ...prevState,
          item_id: e.value,
          item_unit_id: e.value,
          unit: e.rowValue.unit_from_name,
          type: e.rowValue.type,
          name: e.rowValue.name,
          item_units: e.rowValue.item_units,
          [e.for]: {
            name: e.name,
            label: e.label,
            value: e.value,
          },
        }))
        fetchPriceLevelPerItem(e.value, e.rowValue)
      } else if (e.var_name === "price_level_id") {
        setItemDetails((prevState) => ({
          ...prevState,
          price_level_id: e.value,
          item_units: e.rowValue.item_units,
          [e.for]: {
            name: e.name,
            label: e.label,
            value: e.value,
          },
        }))
      }
    } else {
      const { name, value } = e.target
      var vatIn
      var vatEx
      if (name === "cost") {
        vatIn = value !== "" ? parseFloat(value) : 0
        vatEx = parseFloat(vatIn) / 1.12
        setItemDetails((prevState) => ({
          ...prevState,
          [name]: value,
          vat_in: vatIn,
          vat_ex: vatEx,
          vat_component: vatIn - vatEx,
          item_units: e.rowValue?.item_units,
          selling_price: value,
          wholesale_price: value,
          retail_price: value,
        }))
      } else if (name === "margin" || name === "cost_price") {
        var margin =
          name === "margin"
            ? value
            : itemDetails.margin && itemDetails.margin !== null
            ? parseFloat(itemDetails.margin)
            : 0
        var cost_price =
          name === "cost_price"
            ? value
            : itemDetails.cost_price && itemDetails.cost_price !== null
            ? parseFloat(itemDetails.cost_price)
            : 0
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)

        // VAT calculations
        vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        setItemDetails((prev) => ({
          ...prev,
          [name]: value,
          vat_in: percentage,
          vat_ex: vatEx,
          vat_component: vatComponent,
          selling_price: percentage,
          wholesale_price: percentage,
          retail_price: percentage,
          item_units: e.rowValue?.item_units,
        }))
      } else {
        setItemDetails((prevState) => ({
          ...prevState,
          [name]: value,
          item_units: e.rowValue?.item_units,
        }))
      }
    }
  }

  //onEdit
  function handleOnEdit() {
    handleCloseViewItemModal()
    handleShowEditItemModal()
  }

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target
    if (name === "name") {
      setFilterConfig((prev) => {
        return { ...prev, [name]: searchValue }
      })
    } else {
      setFilterConfig((prev) => {
        return { ...prev, [name]: value }
      })
    }
  }
  function handleOnSearchChange(e) {
    setSearchValue(e.target.value)
  }

  const handleSearchItem = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setSaleItems)
    }
  }

  // new api for searching items
  async function handleFetchItems(value, setSaleItems) {
    setSaleItems([])
    const response = await searchItem({ name: value })
    if (response.response) {
      var itemsList = response.response.data.map((data) => {
        var info = data
        info.label = data.name
        info.value = data.id
        return info
      })
      setSaleItems(itemsList)
    } else {
      return toast.error(response.error?.data?.messages.message, {
        style: toastStyle(),
      })
    }
  }

  // FETCH SALE ITEMS
  // async function fetchAllSaleItems() {
  //   setExcelData([])
  //   setSaleItems([])

  //   const response = await searchItem({})
  //   if (response.response) {
  //     var saleItems = response.response.data.sort((a, b) =>
  //       a.name > b.name ? 1 : b.name > a.name ? -1 : 0
  //     )
  //     var data = saleItems.map((item) => {
  //       var info = {}
  //       info.var_name = "item_id"
  //       info.for = "item_id_value"
  //       info.label = item.name
  //       info.value = item.id
  //       info.rowValue = item
  //       return info
  //     })
  //     setSaleItems(data)
  //   }
  // }

  async function fetchPriceLevel() {
    setAllPriceLevels([])
    const response = await searchPriceLevel({})
    if (response.data) {
      var price_levels = response.data.data.map((data) => {
        var info = {}
        info.var_name = "price_level_id"
        info.for = "price_level_id_value"
        info.label = data.name
        info.value = data.id
        return info
      })
      setAllPriceLevels([
        { label: "All Price Levels", value: "" },
        ...price_levels,
      ])
    }
  }

  async function fetchPriceLevelPerItem(id, item_details) {
    setPriceLevels([])
    const response = await getAllPriceLevelsBasedOnItem(id)
    if (response.data) {
      var price_levels = response.data.data.map((data) => {
        var info = {}
        info.var_name = "price_level_id"
        info.for = "price_level_id_value"
        info.label = data.name
        info.value = data.id
        return info
      })
      setPriceLevels(price_levels)
      setFilteredPriceLevels(price_levels)
      if (price_levels.length > 0) {
        // to set the first array to the item units of the selected item
        const newList = [...priceLevelDetails]
        var units = item_details.item_units.map((data) => {
          var info = data
          info.original_cost_price = data.cost_price
          return info
        })
        newList[priceLevelDetails.length - 1] = units
        setPriceLevelDetails(newList)
      }
    } else {
      toast.error(`${item_details.name} has item prices for all price levels`, {
        style: toastStyle(),
      })
    }
  }

  //DELETE or REMOVE ITEM
  function handleDeleteItem() {
    removeItem(selectedID)
  }

  // DROPDOWN SELECT
  function handleSelectChange(e, row) {
    setItemsUnitsMap([])
    fetchItem(row.id)
    setSelectedID(row.id)
    setSelectedRow(row)
    if (e.target.value === "delete-item") {
      handleShowDeleteModal()
    } else if (e.target.value === "edit-item") {
      handleShowEditItemModal()
    } else if (e.target.value === "view-item") {
      handleShowViewItemModal()
    } else if (e.target.value === "generate-barcode") {
      handleExportBarcode(row)
    } else {
      refreshPage()
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-item" className="color-options">
          View
        </option>
        {isAdmin && (
          <option value="edit-item" className="color-options">
            Edit
          </option>
        )}
        {isAdmin && (
          <option value="generate-barcode" className="color-red">
            Generate Barcode
          </option>
        )}
        {isAdmin && (
          <option value="delete-item" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  //API CALL
  async function fetchItemPrices() {
    setShowLoader(true)

    const response = await searchItemPrice(filterConfig)

    if (response.response) {
      var items = []
      var sortedData = response.response.data.sort((a, b) =>
        a.item_name > b.item_name ? 1 : b.item_name > a.item_name ? -1 : 0
      )
      sortedData.map(async (item) => {
        var info = item
        info.id = item.id
        info.item_name = item.item_name
        info.unit = item.unit
        info.selling_price = item.selling_price
          ? numberFormat(item.selling_price)
          : "0.00"
        info.wholesale_price = item.wholesale_price
          ? numberFormat(item.wholesale_price)
          : "0.00"
        info.retail_price = item.retail_price
          ? numberFormat(item.retail_price)
          : "0.00"
        items.push(info)
      })
      setItemsDataBraddex(items)

      var excel = items.map((bill) => {
        var info = {}
        info.item_name = bill.item_name
        info.unit = bill.unit
        info.price_level_name = bill.price_level_name
        info.selling_price = bill.selling_price
        info.wholesale_price = bill.wholesale_price
        info.retail_price = bill.retail_price
        return info
      })
      setExcelData(excel)
    } else {
      setItemsDataBraddex([])
    }
    setShowLoader(false)
  }

  async function fetchItem(id) {
    const response = await getItemPrices(id)
    if (response.data) {
      var data = response.data.data[0]
      data.price_level_id_value = {
        label: data.price_level_name,
        value: data.price_level_id,
      }
      data.item_id_value = {
        label: data.item_name,
        value: data.item_id,
      }
      setItemDetails(data)
      setSaleItemsValue({
        name: "item_id",
        label: data.item_name,
        value: data.item_id,
      })
    } else {
      setItemDetails({})
    }
  }

  async function handleSaveItem() {
    setIsClicked(true)
    const response = await createItemPrice(itemDetails, priceLevelDetails)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      handleCloseAddItemModal()
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  async function handleEditItem() {
    setIsClicked(true)
    const response = await updateItemPrice(itemDetails)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      handleCloseEditItemModal()
      fetchItemPrices()
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  async function removeItem(id) {
    setIsClicked(true)
    const response = await deleteItemPrices(id)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      handleCloseDeleteModal()
      fetchItemPrices()
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  // ADD PRICE LEVEL HANDLER
  function handleAddPriceLevel() {
    var newList = []
    var units = itemDetails.item_units.map((data) => {
      var info = data
      info.original_cost_price = data.cost_price
      return info
    })
    newList = units

    setPriceLevelDetails((oldItems) => [...oldItems, newList])
  }

  // PRICE LEVEL REMOVAL HANDLER
  function handleRemovePriceLevel(id) {
    const rowId = id
    const newItemList = [...priceLevelDetails]
    newItemList.splice(rowId, 1)
    setPriceLevelDetails(newItemList)

    // to filter price level and remove the selected ones in the option
    const flattenedNewList = newItemList.flat() // Flatten the nested arrays
    const filteredOptions = priceLevel.filter((option) => {
      // Check if any object in flattenedNewList has the same price_level_id
      return !flattenedNewList.some(
        (item) => item.price_level_id === option.value
      )
    })

    setFilteredPriceLevels(filteredOptions)
  }

  // updated price level details change
  const handlePriceLevelChange = (e, type, level_index, unit_index) => {
    if (type === "price_level") {
      const { name, value, label } = e
      const newList = [...priceLevelDetails]

      const updatedList = newList.map((subArray, index) => {
        if (index === level_index) {
          // If the current subArray index matches the level_index, update its elements
          return subArray.map((item) => ({
            ...item,
            price_level_id: value,
            price_level_id_value: {
              label: label,
              value: value,
            },
          }))
        }
        return subArray // If not the targeted index, return the subArray unchanged
      })
      // to set select dropdown value
      updatedList[level_index]["price_level_id_value"] = {
        label: label,
        value: value,
      }
      setPriceLevelDetails(updatedList)

      // to filter price level and remove the selected ones in the option
      const flattenedNewList = updatedList.flat() // Flatten the nested arrays
      const filteredOptions = priceLevel.filter((option) => {
        // Check if any object in flattenedNewList has the same price_level_id
        return !flattenedNewList.some(
          (item) => item.price_level_id === option.value
        )
      })

      setFilteredPriceLevels(filteredOptions)
    } else {
      const { name, value } = e.target

      const newList = [...priceLevelDetails]
      newList[level_index][unit_index][name] = value

      if (name === "margin") {
        var margin = value !== "" ? value : 0
        var cost_price = newList[level_index][unit_index]["cost_price"]
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["margin"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      } else if (name === "cost_price") {
        var margin = newList[level_index][unit_index]["margin"]
          ? newList[level_index][unit_index]["margin"]
          : 0
        var cost_price = value !== "" ? value : 0
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["cost_price"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      }
      setPriceLevelDetails(newList)
    }
  }

  // PRICE LEVEL DETAILS CHANGE HANDLER !!!(UNUSED)!!!
  function handlePriceLevelDetailChange(
    e,
    price_level_index,
    type,
    price_key,
    price_level_data
  ) {
    if (type === "dropdown") {
      if (e.var_name === "price_level_id") {
        var newItemList = [...priceLevelDetails]
        newItemList[price_level_index]["price_level_id"] = e.value
        newItemList[price_level_index][e.for] = {
          name: e.name,
          label: e.label,
          value: e.value,
        }
        setPriceLevelDetails(newItemList)
      } else {
        const { name, value } = e.target
        var new_price_level = [...priceLevelDetails]
        var new_item_details = [...itemDetails.item_units]

        if (
          !Array.isArray(new_price_level[price_level_index]["unit"]) &&
          new_price_level[price_level_index]["unit"] === undefined
        ) {
          new_price_level[price_level_index]["unit"] = []
        }

        new_item_details?.forEach((item, index) => {
          if (index === parseInt(price_key)) {
            if (
              !new_price_level[price_level_index].unit[index] &&
              new_price_level[price_level_index].unit[index] === undefined
            ) {
              new_price_level[price_level_index]["unit"][index] = []
            }
            // to set cost price
            if (
              new_price_level[price_level_index].unit[index].cost_price ===
                null ||
              new_price_level[price_level_index].unit[index].cost_price ===
                undefined
            ) {
              var cost = item.cost_price ? item.cost_price : "0"
              new_price_level[price_level_index].unit[index].cost_price = cost
            }

            if (
              new_price_level[price_level_index].unit[index].items === null ||
              new_price_level[price_level_index].unit[index].items === undefined
            ) {
              var items = {
                item_id: item.item_id,
                item_unit_id: item.id,
                unit: item.unit_from,
              }
              new_price_level[price_level_index].unit[index].items = items
            } else {
              // If the items object already exists, update its properties
              new_price_level[price_level_index].unit[index].items.item_id =
                item.item_id
              new_price_level[price_level_index].unit[
                index
              ].items.item_unit_id = item.id
              new_price_level[price_level_index].unit[index].items.unit =
                item.unit_from
            }
            new_price_level[price_level_index].unit[index][name] = value
            if (name === "retail_price") {
              var vatEx = parseFloat(value) / 1.12
              var vatComponent = parseFloat(value) - vatEx
              new_price_level[price_level_index].unit[index].vat_in = value
              new_price_level[price_level_index].unit[index].vat_ex = vatEx
              new_price_level[price_level_index].unit[index].vat_component =
                vatComponent
            } else if (name === "margin") {
              var margin = value !== "" ? value : 0
              var cost_price =
                new_price_level[price_level_index].unit[index].cost_price
              var percentage =
                (parseFloat(cost_price) * parseFloat(margin)) / 100 +
                parseFloat(cost_price)
              new_price_level[price_level_index].unit[index].margin = value
              new_price_level[price_level_index].unit[index].selling_price =
                percentage
              new_price_level[price_level_index].unit[index].wholesale_price =
                percentage
              new_price_level[price_level_index].unit[index].retail_price =
                percentage

              // VAT calculations
              var vatEx = parseFloat(percentage) / 1.12
              var vatComponent = parseFloat(percentage) - vatEx
              new_price_level[price_level_index].unit[index].vat_in = percentage
              new_price_level[price_level_index].unit[index].vat_ex = vatEx
              new_price_level[price_level_index].unit[index].vat_component =
                vatComponent
            } else if (name === "cost_price") {
              var margin = new_price_level[price_level_index].unit[index].margin
                ? new_price_level[price_level_index].unit[index].margin
                : 0
              var cost_price = value !== "" ? value : 0
              var percentage =
                (parseFloat(cost_price) * parseFloat(margin)) / 100 +
                parseFloat(cost_price)
              new_price_level[price_level_index].unit[index].cost_price = value
              new_price_level[price_level_index].unit[index].selling_price =
                percentage
              new_price_level[price_level_index].unit[index].wholesale_price =
                percentage
              new_price_level[price_level_index].unit[index].retail_price =
                percentage

              // VAT calculations
              var vatEx = parseFloat(percentage) / 1.12
              var vatComponent = parseFloat(percentage) - vatEx
              new_price_level[price_level_index].unit[index].vat_in = percentage
              new_price_level[price_level_index].unit[index].vat_ex = vatEx
              new_price_level[price_level_index].unit[index].vat_component =
                vatComponent
            }
          }
        })

        // Assuming you want to update the state with the modified priceLevelDetails
        setPriceLevelDetails(new_price_level)

        // priceLevelDetails.push(new_item_details)
      }
    } else {
      const { name, value } = e.target

      var items = [...priceLevelDetails]
      items[price_level_index][name] = value
      setPriceLevelDetails(items)
    }
  }

  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.value = category.id
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
      //subcategories
      var subcategories = response.data.subcategories.map((category) => {
        var info = {}
        info.value = category.subname
        info.label = category.subname
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)
    }
  }

  function handleExport() {
    const rows = excelData

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "ItemPrices.xlsx", { compression: true })
  }

  function handleExportBarcode(row) {
    var info = {}
    info.qty = ""
    info.barcode = row.barcode
    info.item_code = row.item_code
    info.description = row.item_name
    info.price = row.retail_price
    info.amount = ""
    const rows = [info]

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxBarcodeHeaders], { origin: "A1" })
    XLSX.writeFile(
      workbook,
      `${moment(filterConfig.date_from).format("YYYYMMDD")} - ${
        row.item_name
      }.xlsx`,
      { compression: true }
    )
  }

  useEffect(() => {
    fetchItemPrices()
  }, [filterConfig])

  useEffect(() => {
    // fetchAllSaleItems();
    fetchPriceLevel()
    fetchCategories()
  }, [])

  useEffect(() => {
    var subcat = subCategories.filter((data) => {
      return data.category_id === filterConfig?.category_id
    })
    setFilteredSubCategories(subcat)
  }, [filterConfig.category])

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"MANAGE ITEM"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              ITEM PRICES{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              className="search-bar"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                handleOnSearchChange(e)
              }}
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button
                as={ButtonGroup}
                title="Add"
                id="bg-nested-dropdown"
                className="add-btn"
                eventKey="braddex"
                onClick={handleShowSelectItemModal}
              >
                Add
              </button>
            </div>
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Price Level"
                styles={selectDropdownStyle}
                options={allPriceLevel}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return { ...prev, price_level_id: e.value }
                  })
                }}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Category"
                styles={selectDropdownStyle}
                value={filterConfig.selected_category}
                options={[
                  { label: "All Categories", value: "" },
                  ...categories,
                ]}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      category: e.label,
                      category_id: e.value,
                      selected_category: {
                        value: e.value,
                        label: e.label,
                      },
                    }
                  })
                }}
              />
            </Col>
          </Row>
          <div className="mb-2" />

          {/* table */}
          <TableTemplate
            tableHeaders={[
              "ITEM CODE",
              "ITEM",
              "UNIT",
              "PRICE LEVEL",
              "SELLING PRICE",
              "WHOLESALE PRICE",
              "RETAIL PRICE",
              "ACTIONS",
            ]}
            headerSelector={[
              "item_code",
              "item_name",
              "unit",
              "price_level_name",
              "selling_price",
              "wholesale_price",
              "retail_price",
            ]}
            tableData={itemsDataBraddex}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
          />
        </div>
        <div className="mb-2" />
        <Row>
          <Col lg={10} className="mt-4 mt-lg-0"></Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img
                    alt="download"
                    width={20}
                    height={20}
                    src={downloadIcon}
                  ></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <br />
      </div>

      {/* MODALS */}
      <DeleteModal
        text="item"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteItem}
        isClicked={isClicked}
      />
      <AddModal
        title={`ITEM PRICE`}
        type="item"
        show={showSelectItemModal}
        onHide={handleCloseSelectItemModal}
        onSave={handleShowAddItemModal}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mt-3">
            <Col>
              ITEM NAME
              <SearchBox
                showSearch
                placeholder={"Search Item..."}
                className="react-select-container w-100"
                defaultActiveFirstOption={false}
                dropdownClassName="z-large antdesign-custom-dropdown"
                style={antdesignSelectStyle}
                suffixIcon={null}
                filterOption={false}
                onSearch={handleSearchItem}
                onChange={(e) => handleAddChange(e, "item_id")}
                notFoundContent={null}
                options={(saleItems || []).map((d) => ({
                  value: d.value,
                  label: d.label,
                }))}
              />
            </Col>
          </Row>
        </div>
      </AddModal>
      <AddModal
        title={`ITEM PRICE`}
        type="item"
        show={showAddItemModal}
        onHide={handleCloseAddItemModal}
        onSave={handleSaveItem}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          {priceLevelDetails?.map((data, key) => {
            return (
              <>
                <Row className="nc-modal-custom-row mt-3">
                  <Col xs={6}>
                    PRICE LEVEL
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select price level..."
                      value={data.price_level_id_value}
                      options={filteredPriceLevel}
                      onChange={(e) =>
                        handlePriceLevelChange(e, "price_level", key)
                      }
                      isDisabled={filteredPriceLevel.length > 0 ? false : true}
                    />
                  </Col>
                  <Col xs={4}></Col>
                  <Col xs={2} className="pt-3 PO-add-item">
                    <Button
                      type="button"
                      onClick={() => handleRemovePriceLevel(key)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                {data?.map((item, index) => {
                  return (
                    <>
                      <Row key={index} className="nc-modal-custom-row mt-3">
                        <Col className="unit">{item.unit_from}</Col>
                        <Col>
                          COST
                          <Form.Control
                            type="number"
                            name="cost_price"
                            value={item.cost_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                          />
                        </Col>
                        <Col>
                          MARGIN %
                          <Form.Control
                            type="number"
                            name="margin"
                            value={item.margin}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SELLING PRICE
                          <Form.Control
                            type="number"
                            name="selling_price"
                            value={item.selling_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          WS PRICE
                          <Form.Control
                            type="number"
                            name="wholesale_price"
                            value={item.wholesale_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          RETAIL PRICE
                          <Form.Control
                            type="number"
                            name="retail_price"
                            value={item.retail_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                      </Row>
                      <Row key={index} className="nc-modal-custom-row mt-1">
                        <Col>
                          SPEC PRICE 1
                          <Form.Control
                            type="number"
                            name="special_price_1"
                            value={item.special_price_1}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SPEC PRICE 2
                          <Form.Control
                            type="number"
                            name="special_price_2"
                            value={item.special_price_2}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SPEC PRICE 3
                          <Form.Control
                            type="number"
                            name="special_price_3"
                            value={item.special_price_3}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          VAT IN
                          <Form.Control
                            type="text"
                            name="vat_in"
                            value={
                              item.vat_in ? numberFormat(item.vat_in) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col>
                          VAT EX
                          <Form.Control
                            type="text"
                            name="vat_ex"
                            value={
                              item.vat_ex ? numberFormat(item.vat_ex) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col>
                          VAT COMPONENT
                          <Form.Control
                            type="text"
                            name="vat_component"
                            value={
                              item.vat_component
                                ? numberFormat(item.vat_component)
                                : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                      </Row>
                    </>
                  )
                })}
                <hr />
              </>
            )
          })}
          <Row className="pt-3 PO-add-item">
            <Button
              type="button"
              disabled={filteredPriceLevel.length > 0 ? false : true}
              onClick={() => handleAddPriceLevel()}
            >
              Add Price Level
            </Button>
          </Row>
        </div>
      </AddModal>
      {/* <EditModal
        title="ITEM PRICES"
        type="item"
        show={showEditItemModal}
        onHide={handleCloseEditItemModal}
        onSave={handleEditItem}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6}>
              ITEM NAME
              <Form.Control
                type="text"
                name="item_name"
                value={itemDetails.item_name}
                className="nc-modal-custom-input hide-spinner numeric-input"
                disabled
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2 mt-lg-0 unit">
              Unit: {itemDetails.unit}
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={12}>
              PRICE LEVEL
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select item..."
                value={itemDetails.price_level_id_value}
                options={priceLevel}
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={4}>
              SELLING PRICE
              <Form.Control
                type="number"
                name="selling_price"
                value={itemDetails.selling_price}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              WS PRICE
              <Form.Control
                type="number"
                name="wholesale_price"
                value={itemDetails.wholesale_price}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              RETAIL PRICE
              <Form.Control
                type="number"
                name="retail_price"
                value={itemDetails.retail_price}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={4}>
              SPEC PRICE 1
              <Form.Control
                type="number"
                name="special_price_1"
                value={itemDetails.special_price_1}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SPEC PRICE 2
              <Form.Control
                type="number"
                name="special_price_2"
                value={itemDetails.special_price_2}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              SPEC PRICE 3
              <Form.Control
                type="number"
                name="special_price_3"
                value={itemDetails.special_price_3}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={4}>
              VAT IN
              <Form.Control
                type="number"
                name="vat_in"
                value={numberFormat(itemDetails.vat_in)}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                disabled
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              VAT EX
              <Form.Control
                type="number"
                name="vat_ex"
                value={numberFormat(itemDetails.vat_ex)}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                disabled
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              VAT COMPONENT
              <Form.Control
                type="number"
                name="vat_component"
                value={numberFormat(itemDetails.vat_component)}
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                disabled
              />
            </Col>
          </Row>
        </div>
      </EditModal> */}
      <EditModal
        title="ITEM PRICES"
        type="item"
        show={showEditItemModal}
        onHide={handleCloseEditItemModal}
        onSave={handleEditItem}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          {priceLevelDetails?.map((data, key) => {
            return (
              <>
                <Row className="nc-modal-custom-row mt-3">
                  <Col xs={12} lg={6}>
                    ITEM NAME
                    <Form.Control
                      type="text"
                      name="item_name"
                      value={itemDetails.item_name}
                      className="nc-modal-custom-input hide-spinner numeric-input"
                      disabled
                    />
                  </Col>
                  <Col xs={12} lg={6} className="mt-2 mt-lg-0 unit">
                    Unit: {itemDetails.unit}
                  </Col>
                </Row>
                <Row className="nc-modal-custom-row mt-3">
                  <Col xs={6}>
                    PRICE LEVEL
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select item..."
                      value={itemDetails.price_level_id_value}
                      options={priceLevel}
                      onChange={(e) => handleAddChange(e)}
                    />
                  </Col>
                </Row>
                <>
                  <Row className="nc-modal-custom-row mt-3">
                    <Col className="unit">Unit: {itemDetails.unit}</Col>
                    <Col>
                      COST
                      <Form.Control
                        type="number"
                        name="cost_price"
                        value={itemDetails.cost_price}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                      />
                    </Col>
                    <Col>
                      MARGIN %
                      <Form.Control
                        type="number"
                        name="margin"
                        value={itemDetails.margin}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        required
                      />
                    </Col>
                    <Col>
                      SELLING PRICE
                      <Form.Control
                        type="number"
                        name="selling_price"
                        value={itemDetails.selling_price}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        required
                      />
                    </Col>
                    <Col>
                      WS PRICE
                      <Form.Control
                        type="number"
                        name="wholesale_price"
                        value={itemDetails.wholesale_price}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        required
                      />
                    </Col>
                    <Col>
                      RETAIL PRICE
                      <Form.Control
                        type="number"
                        name="retail_price"
                        value={itemDetails.retail_price}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        required
                      />
                    </Col>
                  </Row>
                  <Row className="nc-modal-custom-row mt-4">
                    <Col>
                      SPEC PRICE 1
                      <Form.Control
                        type="number"
                        name="special_price_1"
                        value={itemDetails.special_price_1}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        required
                      />
                    </Col>
                    <Col>
                      SPEC PRICE 2
                      <Form.Control
                        type="number"
                        name="special_price_2"
                        value={itemDetails.special_price_2}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        required
                      />
                    </Col>
                    <Col>
                      SPEC PRICE 3
                      <Form.Control
                        type="number"
                        name="special_price_3"
                        value={itemDetails.special_price_3}
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        required
                      />
                    </Col>
                    <Col>
                      VAT IN
                      <Form.Control
                        type="text"
                        name="vat_in"
                        value={
                          itemDetails.vat_in
                            ? numberFormat(itemDetails.vat_in)
                            : "0"
                        }
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        disabled
                      />
                    </Col>
                    <Col>
                      VAT EX
                      <Form.Control
                        type="text"
                        name="vat_ex"
                        value={
                          itemDetails.vat_ex
                            ? numberFormat(itemDetails.vat_ex)
                            : "0"
                        }
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        disabled
                      />
                    </Col>
                    <Col>
                      VAT COMPONENT
                      <Form.Control
                        type="text"
                        name="vat_component"
                        value={
                          itemDetails.vat_component
                            ? numberFormat(itemDetails.vat_component)
                            : "0"
                        }
                        className="nc-modal-custom-input hide-spinner numeric-input"
                        onChange={(e) => handleAddChange(e, "item_unit")}
                        disabled
                      />
                    </Col>
                  </Row>
                </>

                <hr />
              </>
            )
          })}
        </div>
      </EditModal>
      <ViewModal
        withHeader
        title="ITEM PRICE"
        withButtons
        show={showViewItemModal}
        onHide={handleCloseViewItemModal}
        onEdit={handleOnEdit}
      >
        <div className="mt-3 ">
          <div className="col-sm-12  space mt-0">
            <div className="container-wrapper mt-0">
              <Row className="nc-modal-custom-row-view mt-3">
                <Col>
                  ITEM NAME
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemDetails.item_name} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div className="container-wrapper mt-3">
              <Row className="nc-modal-custom-row-view mt-3">
                <Col>
                  PRICE LEVEL
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemDetails.price_level_name} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col>
                  SELLING PRICE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.selling_price)} </Col>
                  </Row>
                </Col>
                <Col>
                  WS PRICE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.wholesale_price)} </Col>
                  </Row>
                </Col>
                <Col>
                  RETAIL PRICE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.retail_price)} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col>
                  SPEC PRICE 1
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.special_price_1)} </Col>
                  </Row>
                </Col>
                <Col>
                  SPEC PRICE 2
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.special_price_2)} </Col>
                  </Row>
                </Col>
                <Col>
                  SPEC PRICE 3
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.special_price_3)} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col>
                  VAT IN
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.vat_in)} </Col>
                  </Row>
                </Col>
                <Col>
                  VAT EX
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.vat_ex)} </Col>
                  </Row>
                </Col>
                <Col>
                  VAT COMPONENT
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {numberFormat(itemDetails.vat_component)} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
      <Footer />
    </div>
  )
}
